export const PAGES_URL = {
  DASHBOARD: "",
  LOGIN: "login",
  PRE_LOGIN: "pre-login",
  SUPPORT: "support",
  // TAC: "term-and-conditions",

  NOT_FOUND: "404-not-found",
  STYLES_GUIDE: "styles-guide",
  TRANFER_BY_PHONE: "transfer-money/transfer-by-phone",
  TRANFER_BY_ACCOUNT: "transfer-money/transfer-by-account",
  TRANFER_BY_CARD: "transfer-money/transfer-by-card",
  TRANFER_BY_BATCH: "transfer-money/transfer-by-batch",
  TRANS_INTERNATIONAL: "transfer-money/trans-international",
  CARD_TRANSACTION_LIST: "manage-transaction/card-transaction-list",
  TRANSACTION_LIST: "manage-transaction/list-transaction",
  TRANSACTION_HISTORY: "manage-transaction/transaction-history",
  BENEFICIARY_TEMPLATE: "manage-transaction/beneficiary-template",
  TRANSACTION_DETAIL: "manage-transaction/detail-transaction",
  TRANSACTION_RESPONSE: "manage-transaction/transaction-response",
  ACCOUNTS_LIST: "accounts/list-account",
  ACCOUNTS: "accounts",
  ACCOUNT_DETAIL: "accounts/detail-account",
  CARDS_LIST: "cards/list-cards",
  CARDS: "cards",
  CARD_DETAIL: "cards/detail-card",
  CARD_CREDIT_DETAIL: "cards/credit-detail",
  CARD_TRANSACTION_HISTORY: "cards/transaction-history",
  CARD_TRANSACTION_DETAIL: "cards/transaction-detail",
  CARD_LIMIT_SETTING: "cards/limit-setting",
  CARD_STATEMENT: "cards/statement",
  CARD_STATEMENT_VIEW: "cards/statement-view",
  CARD_PAYMENT: "cards/payment",
  CARD_PAYMENT_CONFIRM: "cards/payment-confirm",
  CARD_UNLOCK: "cards/unlock",
  CARD_LOCK: "cards/lock",
  CARD_ONLINE_PAYMENT: "cards/online-payment",
  CARD_ACTION_RESULT: "cards/action-result",
  BILL_PAYMENT: "manage-payment/bill-payment",
  BILL_PAYMENT_LIST: "manage-payment/bill-payment-list",
  NOTIFICATIONS: "notifications",
  NOTI: "noti",
  SETTING: "setting",
  USER_PROFILE: "setting/user-profile",
  CHANGE_PASSWORD: "setting/change-password",
  USER_LIMIT: "setting/user-limit",
  DEVICE_MANAGEMENT: "setting/device-management",
  NOTIFICATION_SETTINGS: "setting/notification",
  ABOUT: "setting/about",
  TERMS_AND_CONDITIONS: "setting/about/term-and-conditions",
  OPEN_CURRENT_ACCOUNT:
    "setting/about/term-and-conditions/open-current-account",

  FORGOTPASSWORD: "forgot-password",
  FORCE_CHANGE_PASSWORD: "change-password",
  TERM_DEPOSIT_FORM: "term-deposit/form",
  TERM_DEPOSIT: "term-deposit",
  TERM_DEPOSIT_CREATE: "term-deposit/create",
  TERM_DEPOSIT_DETAIL: "term-deposit/term-deposit-detail",
  FINALIZE_DEPOSIT: "term-deposit/finalize-deposit",
  WITHDRAW_ACCOUNT: "term-deposit/withdraw-account",
  ROOT_WITHDRAWAL: "term-deposit/root-withdrawal",
  WITHDRAW_ACCOUNT_RESPONSE: "term-deposit/root-withdrawal-response",
  TERM_COSUMER_LOAN: "term-loan/consumer-loan",
  TERM_LOAN: "term-loan",
  COSUMER_LOAN: "consumer-loan",
  TERM_LOAN_DETAIL: "term-loan/term-loan-detail",
  TERM_LOAN_SETTLEMENT: "term-loan/settlement",
  TERM_LOAN_SETTLEMENT_RESPONSE: "term-loan/consumer-loan-response",
  LOAN_SETTLEMENT: "settlement",
  TERM_DEPOSIT_SETTLEMENT: "term-loan/deposit-settlement",
  DEPOSIT_SETTLEMENT: "deposit-settlement",
  APPROVE_FINAL_SETTLEMENT: "term-deposit/approve-final-settlement",
  APPROVE_FINAL_SETTLEMENT_RESPONSE:
    "term-deposit/approve-final-settlement-response",
  DISBURSEMENT: "credit/disbursement",
  ADD_DISBURSEMENT: "disbursement/add",
  DISBURSEMENT_DETAIL: "credit/disbursement/detail/:code",
  // Module Quản lý tiền vay
  LOAN_MANAGEMENT: "credit/loan-management",
  LOAN_MANAGEMENT_DETAIL: "credit/loan-management/:loanId",
  // 2 luồng tạo yêu cầu — design 12/08/2026 chuyển từ modal sang trang riêng 2 bước
  LOAN_MANAGEMENT_CLOSURE: "credit/loan-management/:id/closure",
  LOAN_MANAGEMENT_PAYMENT: "credit/loan-management/:id/payment",

  LETTER_OF_CREDIT: "credit/letter-of-credit",
  LETTER_OF_CREDIT_DETAIL: "credit/letter-of-credit-detail",
  SHIPPING_DOCUMENTS: "credit/shipping-documents",
  GUARANTEE: "credit/guarantee",
  SHIPPING_DOCUMENTS_DETAIL: "credit/shipping-documents-detail",
  GUARANTEE_DETAIL: "credit/guarantee-deatail",
  GUARANTEE_INSURANCE: "guarantee-issuance",
  // Bảo lãnh dự thầu (AW122) — đường dẫn theo task-breakdown.md của tài liệu dự án.
  // Khác tiền tố "credit/" của màn Bảo lãnh cũ; hai bộ màn chạy song song cho tới khi
  // lead chốt cắt màn cũ.
  GUARANTEE_AW122: "guarantee",
  GUARANTEE_REQUEST_DETAIL: "guarantee/request",
  GUARANTEE_APPROVAL_LIST: "guarantee/approval",
  GUARANTEE_APPROVE: "guarantee/approval/detail",
  GUARANTEE_LETTER_DETAIL: "guarantee/letter",
  // AW122.04/.05/.09 — wizard phát hành (bước 3, 4) và màn bổ sung hồ sơ.
  // Vẫn theo khuôn của module: id yêu cầu đi qua query string ?requestId=, không phải path param.
  GUARANTEE_ISSUE_STEP1: "guarantee/issue/general",
  GUARANTEE_ISSUE_STEP2: "guarantee/issue/amount",
  GUARANTEE_ISSUE_STEP3: "guarantee/issue/documents",
  GUARANTEE_ISSUE_STEP4: "guarantee/issue/confirm",
  // Màn kết quả sau khi nộp đơn — có URL riêng để F5 vẫn thấy được kết quả (bản mẫu `s-done`).
  GUARANTEE_ISSUE_RESULT: "guarantee/issue/result",
  GUARANTEE_SUPPLEMENT: "guarantee/request/supplement",
  MORTGAGE_LOAN_ACCOUNT: "mortgage-loan-account",
  CONVENIENCE_SERVICES: "convenience-services",
  BOOKING_LIST: "booking",
  LETTER_OF_CREDIT_OPENED: "credit/letter-of-credit-opened",
  LETTER_OF_CREDIT_ONLINE: "letter-credit-online",
  REQUIREMENTS_MANAGEMENT: "corporate-governance/requirements-management",
  USER_MANAGEMENT: "corporate-governance/user-management",
  PERMISSION_MANAGEMENT: "corporate-governance/permission-management",
  INFO_BUSINESS_PAGE: "corporate-governance/info-business-page",
  TERM_DEPOSIT_LIST: "term-deposit/term-deposit-list",
  TERM_DETAIL: "term-deposit/term-detail",

  FOREIGN_CURRENCY: "foreign-currency",
  FOREIGN_CURRENCY_EXCHANGE: "foreign-currency/buy-foreign-currency",
  BUY_CURRENCY_EXCHANGE: "foreign-currency/buy-foreign-currency",
  SELL_FOREIGN_CURRENCY: "foreign-currency/sell-foreign-currency",

  DOMESTIC_TAX_PAYMENT: "gov/domestic-tax-payment",
  CUSTOMS_DUTY_PAYMENT: "gov/customs-duty-payment",
  REGISTARTION_FREE: "gov/registration-fee",
  NOP_NSNN_OVERVIEW: "nop-nsnn",
  LOCK_DETAIL: "accounts/lock-detail",
  LOCK_CHECKER_DETAIL: "accounts/lock-checker-detail",
  TRANS_HISTORY_DETAIL: "trans-history-detail",
  LIST_SAVINGS: "term-deposit/list-savings",
  DEPOSIT_SETTLEMENT_SAVINGS: "savings/deposit-settlement",
  PARTIAL_WITHDRAWAL: "savings/partial-withdrawal",
  DEPOSIT_TOPUP: "savings/deposit-topup",
  ONBOARDING: "onboarding",
  CORP_ONBOARDING: "corp-onboarding",
};

export const PATH_NAME = {
  DASHBOARD: "",
  TRANSFER_MONEY: "transfer-money",
  TRANSFER_BY_PHONE: "transfer-by-phone",
  TRANSFER_BY_CARD: "transfer-by-card",
  TRANSFER_BY_ACCOUNT: "transfer-by-account",
  TRANFER_BY_BATCH: "transfer-by-batch",
  MANAGE_TRANSACTION: "manage-transaction",
  TRANSACTION_LIST: "list-transaction",
  TRANSACTION_HISTORY: "transaction-history",
  CARD_TRANSACTION_DETAIL: "transaction-detail",
  BENEFICIARY_TEMPLATE: "beneficiary-template",
  DETAIL_TRANSACTION: "detail-transaction",
  ACCOUNTS: "accounts",
  ACCOUNTS_LIST: "list-account",
  CARDS: "cards",
  CARDS_LIST: "list-cards",
  ACCOUNTS_DETAIL: "detail-current-account",
  CARDS_DETAIL: "detail-card",
  MANAGE_PAYMENT: "manage-payment",
  BILL_PAYMENT: "bill-payment",
  NOTI: "noti",
  NOTIFICATIONS: "notifications",

  SETTING: "setting",
  USER_PROFILE: "user-profile",
  CHANGE_PASSWORD: "change-password",
  USER_LIMIT: "user-limit",
  DEVICE_MANAGEMENT: "device-management",
  NOTIFICATION_SETTINGS: "notification",
  ABOUT: "about",
  TERMS_AND_CONDITIONS: "term-and-conditions",
  OPEN_CURRENT_ACCOUNT: "open-current-account",
  TERM_DEPOSIT: "term-deposit",
  FORM: "form",
  TERM_DEPOSIT_FORM: "term-deposit/form",
  TERM_DEPOSIT_DETAIL: "term-deposit-detail",
  TERM_DEPOSIT_LIST: "term-deposit-list",
  TERM_DETAIL: "term-detail",
  FINALIZE_DEPOSIT: "finalize-deposit",
  TERM_COSUMER_LOAN: "term-loan/consumer-loan",
  TERM_LOAN: "term-loan",
  COSUMER_LOAN: "consumer-loan",
  TERM_LOAN_DETAIL: "term-loan/term-loan-detail",
  TERM_LOAN_SETTLEMENT: "term-loan/settlement",
  LIST_SAVINGS: "list-savings",
  LOAN_SETTLEMENT: "settlement",
  TERM_DEPOSIT_SETTLEMENT: "term-loan/deposit-settlement",
  DEPOSIT_SETTLEMENT: "deposit-settlement",
  TRANSACTION_RESPONSE: "transaction-response",
  LETTER_OF_CREDIT: "letter-of-credit",
  SHIPPING_DOCUMENTS: "shipping-documents",
  GUARANTEE: "Guarantee",
  LETTER_OF_CREDIT_DETAIL: "letter-of-credit-detail",
  SHIPPING_DOCUMENTS_DETAIL: "shipping-documents-detail",
  GUARANTEE_DETAIL: "Guarantee-deatail",
  GUARANTEE_INSURANCE: "guarantee-issuance",
  MORTGAGE_LOAN_ACCOUNT: "mortgage-loan-account",
  CONVENIENCE_SERVICES: "convenience-services",
  BOOKING_LIST: "booking",

  FOREIGN_CURRENCY: "foreign-currency",
  FOREIGN_CURRENCY_EXCHANGE: "buy-foreign-currency",
  BUY_CURRENCY_EXCHANGE: "buy-foreign-currency",
  SELL_FOREIGN_CURRENCY: "sell-foreign-currency",

  NOP_NSNN: "nop-nsnn",
  GOV: "gov",
  DOMESTIC_TAX_PAYMENT: "domestic-tax-payment",
  CUSTOMS_DUTY_PAYMENT: "customs-duty-payment",
  REGISTARTION_FREE: "registration-fee",
  TRANS_HISTORY_DETAIL: "trans-history-detail",
  CORPORATE_GOVERNANCE: "corporate-governance",
  PERMISSION_MANAGEMENT: "permission-management",
  DEPOSIT_SETTLEMENT_SAVINGS: "deposit-settlement",
  PARTIAL_WITHDRAWAL: "partial-withdrawal",
};

export const API_ERROR_CODE = {
  TOKEN_INVALID: "401",
};

export const RESULT_CODE = {
  SUCCESS: "0",
  CAPTCHA_INCORRECT: "CAPTCHA-0003",
  CAPTCHA_SESSION_EXPIRED_ONE: "ESM-0009",
  CAPTCHA_SESSION_EXPIRED_TWO: "ESM-9002",
  CAPTCHA_SESSION_EXPIRED_THREE: "ESM-9004",
  CAPTCHA_INFORMATION_NOT_MATCH_TRANSACTION: "ESM-9016",
  NOT_FOUND_PROVINCE: "CITAD-00002",
  DISCONNECT_SIGNATURE: "CONNECT-9999",
  OTP_FAILED_INPUT: "OTP_FAIL_INPUT",
  OTP_NOT_FOUND_TRANS: "OTP_NOT_FOUND_TRANS",
  OTP_OVER_RESEND: "OTP_OVER_RESEND",
  OTP_FAIL_OVER_INPUT: "OTP_FAIL_OVER_INPUT",
  REQUEST_CHANGE_TO_CITAD_METHOD_ONE: "404",
  REQUEST_CHANGE_TO_CITAD_METHOD_TWO: "@100#99#",
  REQUEST_CHANGE_TO_CITAD_METHOD_THREE: "@999#90#",
  REQUEST_CHANGE_TO_CITAD_METHOD_FOUR: "ESM-9984",
  SUGGESS_CHANGE_TO_CITAD: "ESM-3004",
  OTP_CLOSE_MODAL: "ESM-2078",
  // Mã lỗi OTP thật của authen-service. Chỉ những mã này mới được coi là "người dùng nhập sai/hết hạn";
  // mọi mã khác là lỗi hệ thống và phải hiển thị resultDesc của backend.
  OTP_EXPIRED: "ESM-8801",
  OTP_WRONG: "ESM-8802",
  OTP_EXCEEDED: "ESM-8803",
};

export const USER_TYPE = {
  KHDN: "9",
  KHCN: "1",
};

export const USER_ROLE_KHDN = {
  ADMIN: "ADMIN",
  CHECKER: "CHECKER",
  MAKER: "MAKER",
};

export const FUNCTION_NAME = {
  GET_CAPTCHA: "getCaptcha",
  LOGIN: "secureLoginWeb",
  GET_LIST_SOURCE_ACCOUNT: "getListSourceAccountLink",
  GET_BALANCE_AMOUNT: "getBalanceAmount",
  GET_PRODUCT_RECENTLY_BY_CATEGORY_CODE: "getProductRecentlyByCategoryCode",
  GET_CREDIT_NUMBER_INFO: "getCreditNumberInfo",
  GET_PROMOCY: "getPromocy",
  INIT_CORP_TRANSFER_TO_INTERNAL: "initCorpTransferToInternal",
  CORP_TRANSFER_TO_INTERNAL: "corpTransferToInternal",
  CORP_SAVE_PRODUCT_RECENTLY_BY_TRANS_ID: "corpSaveProductRecentlyByTransId",
  GET_LIST_DOMESTIC_BANK: "getListDomesticBank",
  GET_CORE_BANK_CREDIT_INFO: "getCorebankCreditInfo",
  GET_BANK_ACCOUNT_NUMBER_INFO: "getBankAccountNumberInfo",
  GET_LIST_PROVINCE_INFO: "getListProvinceInfo",
  INIT_CORP_TRANSFER_OTHER_BANK_BY_ACCOUNT:
    "initCorpTransferOtherBankByAccount",
  INIT_CORP_TRANSACTION_TRANSFER_VIA_CITAD:
    "initCorpTransactionTransferViaCitad",
  CORP_TRANSFER_OTHER_BANK_BY_ACCOUNT: "corpTransferOtherBankByAccount",
  CORP_TRANSFER_VIA_CITAD: "corpTransferViaCitad",
  GET_BANK_CARD_NUMBER_INFO: "getBankCardNumberInfo",
  INIT_CORP_TRANSFER_OTHER_BANK_BY_CARD: "initCorpTransferOtherBankByCard",
  SAV_CORP_SAVING_ACCOUNT: "savCorpSavingAccount",
  BATCH_UPLOAD_FILE: "batchUploadFile",
  BATCH_UPLOAD_FILE_OTP: "batchUploadFileOtp",
  BATCH_UPLOAD_FILE_CONFIRM: "batchUploadFileConfirm",
  GET_LIST_CATEGORY_BY_ROOT: "getListCategoryByRoot",
  CORP_TRANSFER_LIST: "corpTransferList",
  GET_TRANSACTION_DETAIL: "getTransactionDetail",
  GET_CORP_LIST_EWALET_DETAIL: "getCorpListEwaletDetail",
  INIT_CORP_APPROVE_TRANSFER: "initCorpApproveTransfer",
  CORP_APPROVE_TRANSFER: "corpApproveTransfer",
  CORP_REJECT_TRANSACTION: "corpRejectTransaction",
  GET_BATCH_TRANSFER_LIST: "getBatchTransferList",
  CORP_REJECT_BATCH: "corpRejectBatch",
  INIT_CORP_APPROVE_BATCH_TRANSFER: "initCorpApproveBatchTransfer",
  CORP_APPROVE_BATCH_TRANSFER: "corpApproveBatchTransfer",
  PAYMENT_ORDER_HASH_FILE: "paymentOrderHashFile",
  GET_AUTH_TYPE: "getAuthType",
  DOWNLOAD_FILE_UNC: "downloadFileUNC",
  GET_ACCOUNT_MANAGEMENT: "getAccountManagement",
  GET_CORP_LIST_PRODUCT_CATEGORY: "getCorpListProductCategory",
  GET_CORP_TRANSACTION_HISTORY: "getCorpTransactionHistory",
  GET_LIST_STATEMENT: "getListStatement",
  COUNT_TRANSFER: "countTransfer",
  GET_NOTIFICATION_STICKY: "getNotificationSticky",
  SEND_OTP_MANUAL: "sendOTPManual",
  GET_NAPAS_LIMITED_AMOUNT: "getNapasLimitedAmount",
  GET_LIST_PROVIDER: "getListProvider",
  GET_BILL_INFO: "getBillInfo",
  INIT_CORP_TRANSACTION_PAYMENT: "initCorpTransactionPayment",
  CORP_BILL_PAYMENT: "corpBillPayment",
  BOOKING_LIST: "booking",
};

export const TRANSFER_DIRECTORY_STATUS = {
  SAVED: "S",
  RECENT: "R",
};

export const TRANSFER_BY_PHONE_STEPS = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
  STEP_FOUR: 3,
};

export const TRANSFER_BY_ACCOUNT_STEPS = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
  STEP_FOUR: 3,
};

export const TRANSFER_BY_CARD_STEPS = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
  STEP_FOUR: 3,
};

export const TRANSFER_BY_BATCH_STEPS = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
  STEP_FOUR: 3,
};

export const TRANSACTION_APPROVE_STEPS = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
  STEP_FOUR: 3,
};

export const BILL_PAYMENT_STEPS = {
  STEP_ONE: 0,
  STEP_TWO: 1,
  STEP_THREE: 2,
};

export const BANK_TYPE = {
  INTERNAL: "I",
  EXTERNAL: "E",
};

export const CATEGORY_CODE = {
  CATEGORY_CODE_TO_INTERNAL: "D_TRANSFER_TO_LPB_ACCOUNT",
  CATEGORY_CODE_NAPAS_247: "D_TRANSFER_DOMESTIC_ACCOUNT",
  CATEGORY_CODE_NORMAL: "D_TRANSFER_TO_OTHER_BANK_CITAD",
};

export const TRANSFER_TYPE = {
  NAPAS: "NAPAS",
  CITAD: "CITAD",
};

export const GROUP_TYPE = {
  CORE_WALLET: "COREVV",
  CORE_BANK: "COREBANK",
};

export const SOURCE_TYPE = {
  CORE_VV: "COREVV",
  TKTT: "TKTT",
  TKTK: "TKTK",
  TKVAY: "TKVAY",
};

export const AUTH_TYPE = {
  DIGITAL_SIGNATURE: "7",
  SMS: "2",
};

export const ACCOUNT_STATUS = {
  ACTIVE: "A",
  CLOSE: "C",
  LOCK_BY_SYSTEM: "S",
  LOCK_BY_CLIENT: "K",
  LOCK: "L",
  BLOCK: "B",
  OPEN: "O",
};

export const APPROVE_STATUS = {
  APPROVED: "A",
  WAITING_APPROVED: "C",
  REJECT: "B",
};

export const NOTIFICATIONS_TYPE = {
  NORMAL: "0",
  REQUEST_TRANSACTION: "1",
  PROMOTION: "2",
  UPDATE_CUSTOMER: "3",
  TRANSACTION_PENDING: "4",
  BANK_SERVICE: "5",
  CONFIRM_REWARD: "6",
  LUCKEY_MONEY: "7",
  RESEND_EMAIL_WHEN_BUY_CARD: "11",
};

export const MAXIMUM_AMOUNT = 100000000;

export const MINIMUM_AVAIABLE_BALANCE = 50000;

export const LIMIT_PAGE_SIZE = 10;

export const SIGN_HERE_URL = "ws://localhost:7979/echo";
